import { IPoojari, IRitual } from 'pages/apps/Poojari/types';
import { PoojariActionTypes } from './constants';

// Add IRitual type import (adjust the import path as needed)

const INIT_STATE: State = {
    loading: false,
    results: [],
    poojariDetailsById: null,
    rituals: [], // Added rituals to initial state
    isPoojariCreated: false,
    isPoojariUpdated: false,
    importLoading: false,
    importSuccess: false,
    importErrors: [] as string[],
    importProgress: 0,
};

type PoojariActionType = {
    type:
    | PoojariActionTypes.API_RESPONSE_SUCCESS
    | PoojariActionTypes.API_RESPONSE_ERROR
    | PoojariActionTypes.GET_POOJARIS
    | PoojariActionTypes.GET_POOJARI_DETAILS
    | PoojariActionTypes.UPDATE_POOJARI
    | PoojariActionTypes.ADD_POOJARI
    | PoojariActionTypes.DELETE_POOJARI
    | PoojariActionTypes.GET_ALL_RITUALS
    | PoojariActionTypes.BULK_IMPORT_POOJARIS
    | PoojariActionTypes.RESET_IMPORT_STATE
    | '@@poojari/BULK_IMPORT_PROGRESS'
    | PoojariActionTypes.RESET;

    payload: {
        actionType?: string;
        data?: any;
        error?: string | string[];
        progress?: number;
    };
};

type State = {
    results: IPoojari[];
    loading?: boolean;
    error?: string;
    poojariDetailsById: IPoojari | null;
    rituals?: IRitual[];
    isPoojariCreated: boolean;
    isPoojariUpdated: boolean;
    importLoading: boolean;
    importSuccess: boolean;
    importErrors: string[];
    importProgress: number;
};

const Poojaris = (state: State = INIT_STATE, action: PoojariActionType) => {
    switch (action.type) {
        case PoojariActionTypes.API_RESPONSE_SUCCESS: {
            const { actionType, data } = action.payload;
            switch (actionType) {
                case PoojariActionTypes.GET_POOJARIS: {
                    return {
                        ...state,
                        loading: false,
                        results: action.payload.data?.poojaris || action.payload.data?.results || (Array.isArray(action.payload.data) ? action.payload.data : []),
                        isPoojariCreated: false,
                        isPoojariUpdated: false,
                    };
                }

                case PoojariActionTypes.GET_POOJARI_DETAILS:
                    return {
                        ...state,
                        poojariDetailsById: (data as IPoojari) || null,
                        loading: false,
                    };

                case PoojariActionTypes.UPDATE_POOJARI: {
                    const updated = data as IPoojari;

                    return {
                        ...state,
                        results: state.results.map((p) =>
                            p.id === updated.id ? updated : p
                        ),
                        isPoojariUpdated: true,
                        loading: false,
                    };
                }

                case PoojariActionTypes.ADD_POOJARI: {
                    return {
                        ...state,
                        results: [data as IPoojari, ...state.results],
                        poojariDetailsById: data as IPoojari,
                        isPoojariCreated: true,
                        loading: false,
                    };
                }

                case PoojariActionTypes.DELETE_POOJARI: {
                    return {
                        ...state,
                        results: state.results.filter(
                            (poojari) => poojari.id !== data
                        ),
                        loading: false,
                    };
                }
                case PoojariActionTypes.GET_ALL_RITUALS: {
                    return {
                        ...state,
                        rituals: action.payload.data,
                        loading: false,
                    };
                }

                case PoojariActionTypes.BULK_IMPORT_POOJARIS:
                    return {
                        ...state,
                        importLoading: false,
                        importSuccess: true,
                        importProgress: 100,
                        importErrors: [],
                    };
                    
                case '@@poojari/BULK_IMPORT_PROGRESS':
                    return {
                        ...state,
                        importProgress: action.payload.progress || 0,
                    };

                default:
                    return { ...state };
            }
        }
        case PoojariActionTypes.API_RESPONSE_ERROR: {
            const { actionType, error } = action.payload;
            if (actionType === PoojariActionTypes.BULK_IMPORT_POOJARIS) {
                return {
                    ...state,
                    importLoading: false,
                    importSuccess: false,
                    importErrors: Array.isArray(error) ? error : [error as string || 'An error occurred'],
                };
            }
            switch (actionType) {
                case PoojariActionTypes.GET_POOJARIS: {
                    return {
                        ...state,
                        error: error,
                    };
                }
                case PoojariActionTypes.GET_POOJARI_DETAILS: {
                    return {
                        ...state,
                        error: error,
                        loading: false,
                    };
                }
                case PoojariActionTypes.UPDATE_POOJARI: {
                    return {
                        ...state,
                        error: error,
                        loading: false,
                    };
                }
                case PoojariActionTypes.ADD_POOJARI: {
                    return {
                        ...state,
                        error: error,
                        loading: false,
                    };
                }
                case PoojariActionTypes.DELETE_POOJARI: {
                    return {
                        ...state,
                        error: error,
                        loading: false,
                    };
                }
                case PoojariActionTypes.GET_ALL_RITUALS: {
                    return {
                        ...state,
                        error: error,
                        loading: false,
                    };
                }
                default:
                    return { ...state };
            }
        }
        case PoojariActionTypes.GET_POOJARIS:
            return { ...state, loading: true };
        case PoojariActionTypes.GET_POOJARI_DETAILS:
            return { ...state, loading: true };
        case PoojariActionTypes.UPDATE_POOJARI:
            return { ...state, loading: true };
        case PoojariActionTypes.DELETE_POOJARI:
            return { ...state, loading: true };
        case PoojariActionTypes.GET_ALL_RITUALS:
            return { ...state, loading: true };

        case PoojariActionTypes.BULK_IMPORT_POOJARIS:
            return {
                ...state,
                importLoading: true,
                importSuccess: false,
                importErrors: [],
                importProgress: 0,
            };

        case PoojariActionTypes.RESET_IMPORT_STATE:
            return {
                ...state,
                importLoading: false,
                importSuccess: false,
                importErrors: [],
                importProgress: 0,
            };

        case PoojariActionTypes.RESET:
            return {
                ...INIT_STATE,
            };
        default:
            return { ...state };
    }
};

export default Poojaris;
